/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A remote MCP server configuration
 */
export type RemoteMcpServer = {
  /**
   * When the remote MCP server was created
   */
  createdAt: Date;
  /**
   * The ID of the remote MCP server
   */
  id: string;
  /**
   * Optional human-readable name for the remote MCP server
   */
  name?: string | undefined;
  /**
   * The project ID this remote MCP server belongs to
   */
  projectId: string;
  /**
   * URL-friendly slug derived from the URL and ID.
   */
  slug?: string | undefined;
  /**
   * The transport type for the remote MCP server
   */
  transportType: string;
  /**
   * When the remote MCP server was last updated
   */
  updatedAt: Date;
  /**
   * The URL of the remote MCP server
   */
  url: string;
};

/** @internal */
export const RemoteMcpServer$inboundSchema: z.ZodMiniType<
  RemoteMcpServer,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    name: z.optional(z.string()),
    project_id: z.string(),
    slug: z.optional(z.string()),
    transport_type: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    url: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "project_id": "projectId",
      "transport_type": "transportType",
      "updated_at": "updatedAt",
    });
  }),
);

export function remoteMcpServerFromJSON(
  jsonString: string,
): SafeParseResult<RemoteMcpServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RemoteMcpServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RemoteMcpServer' from JSON`,
  );
}
